import React from 'react';
import { CMSContent } from '../components/cms/CMSContent';
import SEO from '../components/SEO';

/**
 * Cancellation & Refund Policy — public page.
 * Legal Corpus V1: the operational refund detail lives in per-order
 * `cancellation_and_refund_conditions` — the single canonical
 * cancellation/refund authority (also served by the public footer and
 * frozen per-quote at issuance). This page serves the
 * *global* Cancellation & Refund framework so it is visible outside a
 * specific order — required for iyzico + consumer transparency.
 */
const RefundPolicyPage = () => (
  <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8" data-testid="refund-policy-page">
    <SEO
      title="Cancellation & Refund Policy"
      description="TreatX Cancellation and Refund Policy — global framework covering booking cancellations, refunds and dispute handling. Per-order terms take precedence."
      canonicalPath="/refund-policy"
    />
    <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-sm p-6 sm:p-8 lg:p-10">
      <CMSContent
        contentKey="cancellation_and_refund_conditions"
        showTitle={true}
        showSummary={false}
        showLegalMetadata={true}
      />
      <p className="mt-4 text-xs text-slate-500">
        Order-specific cancellation terms are attached to each Order and
        take precedence for that Order.
      </p>
    </div>
  </div>
);

export default RefundPolicyPage;
